"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCosmosChainsForChainIds = void 0;
const squid_types_1 = require("@0xsquid/squid-types");
function getCosmosChainsForChainIds({ chainIds, chains }) {
    return chains.filter(c => c.chainType === squid_types_1.ChainType.COSMOS &&
        // if chainIds is not provided, return all cosmos chains
        chainIds.length === 0
        ? true
        : // else return only chains that are in chainIds
            chainIds?.includes(c.chainId));
}
exports.getCosmosChainsForChainIds = getCosmosChainsForChainIds;
//# sourceMappingURL=cosmos.js.map